import React, { ReactNode, useContext, useEffect, useState } from 'react';
import Container from "../layout/Container";
import { CasinoModal } from "../pop_pages/minigame/casino_popup";
import { SlotModal } from "..//pop_pages/minigame/slot_popup";
import { DepositModal } from "../pop_pages/minigame/request_deposit";
import { WithdrawalModal } from "../pop_pages/minigame/request_withdrawal";
import { NoticeModal } from "../pop_pages/board/notice_popup";
import { UserBtn, Userinfo } from "../pop_pages/user/user";
import { actionContext } from "../../app/page";
import { CommingSoonModal } from "../pop_pages/comming_soon";
import { UserContext } from "../../app/_root";
import { loadingContext } from "../provider/game_loading_provider";
import MinigamePopup from "../pop_pages/minigame/minigame_popup";
import ReelPopup from "../pop_pages/minigame/reel_popup";
import { Logo_1 } from './logo';
import NavIcon from '../layout/navIcon';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBars, faHamburger } from '@fortawesome/free-solid-svg-icons';
import api from '../../util/api';
import swal from "sweetalert"

function HeaderNavBar() {
    // const {user, mutateUser} = useUser()
    const { User, MutateUser } = useContext(UserContext)
    const { SetLoadingPop } = useContext(loadingContext)
    const [whoamiLoadingState, setWhoamiLoadingState] = useState<boolean>(false)
    useEffect(() => {
        if (User) {
            SetLoadingPop(false)
            setWhoamiLoadingState(true)
        }
    }, [User])
    return (
        <header id={'header-nav'} className={whoamiLoadingState ? "" : "whoami-loading-event-false"}>

            <MobileTop />
            <div className='top pc'>
                <LogoSpan />
                {
                    User ? User.is_authenticated ? <Userinfo user={User} mutateUser={MutateUser} />
                        : <UserBtn />
                        : <></>
                }
            </div>
            <div className='bot pc'>
                <Container>
                    <Navigation />
                </Container>
            </div>
        </header>
    );
}

export default HeaderNavBar;


function MobileTop() {
    const [hiddenModalShow, setHiddenModalShow] = useState<boolean>(false)
    return (
        <div className="mobile-top">
            <div className={`hidden-manu ${hiddenModalShow ? "active" : ""}`}
                onClick={e => setHiddenModalShow(!hiddenModalShow)}>
                <FontAwesomeIcon icon={faBars} />
            </div>
            <div className={`hidden-nav ${hiddenModalShow ? "active" : ""}`}>
                <div className='nav-modal' onClick={e => setHiddenModalShow(false)}></div>
                <Navigation />
            </div>
        </div>
    )
}


function LogoSpan() {
    return (
        <div className={"v2-logo"} onClick={e => window.location.href = '/'}>
            <Logo_1 />
        </div>
    )
}

interface navInfoInterface {
    popkey: string
    ko: string
    en: string
}
function Navigation() {
    const nav: navInfoInterface[] = [
        {
            popkey: "casino",
            ko: "카지노",
            en: "CASINO"
        },
        {
            popkey: "slot",
            ko: "슬롯머신",
            en: "SLOT"
        },
        // {
        //     popkey: "reel",
        //     ko: "릴게임",
        //     en: "REEL"
        // },
        {
            popkey: "holdem",
            ko: "홀덤",
            en: "HOLDEM"
        },
        // {
        //     popkey: "minigame",
        //     ko: "미니게임",
        //     en: "MINI GAME"
        // },
        {
            popkey: "request_deposit",
            ko: "입금신청",
            en: "DEPOSIT"
        },
        {
            popkey: "request_withdrawal",
            ko: "출금신청",
            en: "WITHDRAWAL"
        },
        {
            popkey: "notice",
            ko: "공지사항",
            en: "NOTICE"
        },
    ]

    function NavItem({ index, navInfo }: { index: number, navInfo: navInfoInterface }) {
        return (
            <>
                {/* {
                    index > 0 ? <span className='line'></span> : <></>
                } */}
                <PopNav key={index} navInfo={navInfo} />
            </>
        )
    }
    return (
        <nav>
            <ul>
                {
                    nav.map((navInfo, index) => (
                        <NavItem key={index} index={index} navInfo={navInfo} />
                    ))
                }
            </ul>
        </nav>
    )
}

function PopNav({ navInfo }: { navInfo: navInfoInterface }) {
    const { User } = useContext(UserContext)
    const { SetLoginPop } = useContext(actionContext)
    const [show, setShow] = useState<boolean>(false)

    let modal: ReactNode = <></>;
    switch (navInfo.popkey) {
        case "casino":
            modal = (<CasinoModal popShow={show} setPopShow={setShow} title={navInfo.ko} />)
            break;
        case "slot":
            modal = (<SlotModal popShow={show} setPopShow={setShow} title={navInfo.ko} />)
            break;
        case "holdem":
            modal = (<CommingSoonModal popShow={show} setPopShow={setShow} />)
            break;
        case "reel":
            modal = (<CommingSoonModal popShow={show} setPopShow={setShow} />)
            // modal = <ReelPopup popShow={show} setPopShow={setShow} />
            break;
        case "minigame":
            modal = (<CommingSoonModal popShow={show} setPopShow={setShow} />)
            // modal = <MinigamePopup popShow={show} setPopShow={setShow} />
            break;
        case "request_deposit":
            modal = (<DepositModal popShow={show} setPopShow={setShow} title={navInfo.ko} />)
            break;
        case "request_withdrawal":
            modal = (<WithdrawalModal popShow={show} setPopShow={setShow} />)
            break;
        case "notice":
            modal = (<NoticeModal registerPopShow={show} setRegisterPopShow={setShow} />)
            break;
    }
    // const [modal, setModal] = useState<React.ReactNode>()

    // useEffect(()=> {
    //     switch (navInfo.popkey) {
    //         case "casino":
    //             setModal(<CasinoModal popShow={show} setPopShow={setShow} title={navInfo.ko} />)
    //             break;
    //         case "slot":
    //             setModal(<SlotModal popShow={show} setPopShow={setShow} title={navInfo.ko} />)
    //             break;
    //         case "holdem":
    //             setModal(<CommingSoonModal popShow={show} setPopShow={setShow} />)
    //             break;
    //         case "reel":
    //             setModal(<CommingSoonModal popShow={show} setPopShow={setShow} />)
    //             // modal = <ReelPopup popShow={show} setPopShow={setShow} />
    //             break;
    //         case "minigame":
    //             setModal(<CommingSoonModal popShow={show} setPopShow={setShow} />)
    //             // modal = <MinigamePopup popShow={show} setPopShow={setShow} />
    //             break;
    //         case "request_deposit":
    //             setModal(<DepositModal popShow={show} setPopShow={setShow} title={navInfo.ko} />)
    //             break;
    //         case "request_withdrawal":
    //             setModal(<WithdrawalModal popShow={show} setPopShow={setShow} />)
    //             break;
    //         case "notice":
    //             setModal(<NoticeModal registerPopShow={show} setRegisterPopShow={setShow} />)
    //             break;
    //     }
    // }, [])

    function holdemGetLink() {
        api(`/api/game/games/link/realpoker`)
            .then(res => res.json())
            .then((data: { link: string }) => {
                if (data?.link) {
                    window.open(data.link, 'holdem pop', 'width=1200 height=640')
                }
            })
            .catch((res: Response) => {
                ErrorHandler(res)
            })
    }
    async function ErrorHandler(res: Response) {
        const message = await res.json()
        swal({
            text: message,
            icon: "error"
        })
    }
    return (
        <>
            {modal}
            <li className={"--pointer"}
                onClick={e => {
                    if (User?.is_authenticated) {
                        setShow(true)
                        // if (navInfo.popkey == 'holdem') {
                        //     holdemGetLink();
                        // } else {
                        //     setShow(true)
                        // }
                    } else {
                        SetLoginPop()
                    }
                }}>
                {/* <NavIcon type={navInfo.popkey} /> */}
                <strong>{navInfo.ko}</strong>
            </li>
        </>
    )
}
